module.exports = __webpack_public_path__ + "static/media/login.5d84417a.jpg";